import { $host } from "./index";

export const fetchAmenities = async (clinicId) => {
  const { data } = await $host.get('web/amenities/');
  return data;
};

export const createAmenity = async (amenityData) => {
  const { data } = await $host.post('web/amenities/', amenityData);
  return data;
};

export const updateAmenityStatus = async (id, newStatus) => {
  const { data } = await $host.put(`web/amenities/${id}`, { 
    isActive: newStatus 
  });
  return data;
};

export const deleteAmenity = async (id) => {
  await $host.delete(`web/amenities/${id}`);
};